import React from "react";
import { css } from "@emotion/core";
import { StaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

export default () => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(
          relativePath: { eq: "features/anana-vestige-transition-image.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1920) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        loading="eager"
        css={css`
          position: absolute !important;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
        `}
        fluid={data.placeholderImage.childImageSharp.fluid}
      />
    )}
  />
);
